import { FormattedMessage, useIntl } from 'react-intl';
import { Button, ButtonGroup, Modal, Stack, Text } from '@mollie/ui-react';

import { modalMessages } from '../../messages';

interface UnsubscribeAllModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export function UnsubscribeAllModal({ onConfirm, onCancel }: UnsubscribeAllModalProps) {
  const intl = useIntl();

  return (
    <Modal open onClose={onCancel} title={intl.formatMessage(modalMessages.title)} size="small">
      <Stack spacing="space-300">
        <Text variant="body-regular">
          <FormattedMessage {...modalMessages.body} />
        </Text>
        <ButtonGroup>
          <Button variant="secondary" onClick={onCancel}>
            <FormattedMessage {...modalMessages.cancel} />
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            <FormattedMessage {...modalMessages.confirm} />
          </Button>
        </ButtonGroup>
      </Stack>
    </Modal>
  );
}
